module.exports = __webpack_public_path__ + "static/example-03-main-2b88cac90fc43f81ddc2724c509a818a.png";